/* eslint-disable */
import { makeAutoObservable } from "mobx";
import FaqApiClient, { FAQItem, GetFAQsResponse, SaveQuestionsResponse } from "../api/FAQApi";

class ApplicationStore {
    applicationApi: FaqApiClient;
    constructor(applicationApi: FaqApiClient) {
        makeAutoObservable(this);
        this.applicationApi = applicationApi
    }

    LoadPropertyListAsync = async () => {
        return this.applicationApi.getPropertyListAsync();
    }

    getFAQs = async (propertyId: string):Promise<GetFAQsResponse> => {
        return await this.applicationApi.getFAQs(propertyId);
    }

    saveQuestions = async (data: FAQItem[]):Promise<SaveQuestionsResponse> => {
        return await this.applicationApi.saveQuestions(data);
    }
}
export default ApplicationStore